import { Icon, IconName } from "@silversea-ssc/ui-components-react"
import { isPresent } from "../../../../_common/checks"
import styles from "./FarePromoBadge.module.scss"

type Props = {
    iconUrl?: string
    icon?: IconName
    title?: string
}

const FarePromoBadge: React.FC<Props> = ({ iconUrl, icon = "promo", title }) => {
    return (
        <div className={styles.container}>
            {isPresent(iconUrl) ? (
                <img src={iconUrl} className={styles.iconUrl} alt={title} loading="lazy" />
            ) : (
                <Icon name={icon} size={"1x"} padding={"inline"} wrapperClassName={styles.icon} />
            )}
            {title}
        </div>
    )
}

export default FarePromoBadge
